import {TableCellProps} from 'react-markdown/lib/ast-to-react';

import {Text} from '#component/base';

import {tableCell} from '../Markdown.css';

export const TableCell = ({children}: React.PropsWithChildren<TableCellProps>) => {
  return (
    <Text as="td" color="doveGray" className={tableCell}>
      {children}
    </Text>
  );
};
